import { render, staticRenderFns } from "./MailboxAliasesView.vue?vue&type=template&id=8d7b0292&"
import script from "./MailboxAliasesView.vue?vue&type=script&lang=js&"
export * from "./MailboxAliasesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d7b0292')) {
      api.createRecord('8d7b0292', component.options)
    } else {
      api.reload('8d7b0292', component.options)
    }
    module.hot.accept("./MailboxAliasesView.vue?vue&type=template&id=8d7b0292&", function () {
      api.rerender('8d7b0292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/mailbox/MailboxAliasesView.vue"
export default component.exports